export const filterMixin = {
  data: function () {
    return {
      isFilterInitialized: false,
      filter: {}
    }
  },
  methods: {
    setFilter(filter, isChange = false) {
      this.isFilterInitialized = true;
      this.filter = Object.assign({}, filter);
      if (isChange && this.tableOptions) {
        this.tableOptions.currentPage = 1;
      }
      if (this.loadData) {
        this.loadData();
      }
    }
  }
};